import React from "react";
import { Sparkles } from "lucide-react"; // sparkle icon
// If you don't want lucide, substitute with any icon.

const ProgressCircle = ({ value = 95 }) => {
  const radius = 14;                 // radius of the circle
  const strokeWidth = 4;             // ring thickness
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (value / 100) * circumference;

  return (
    <div className="relative w-6 h-6">
      <svg
        className="w-full h-full transform -rotate-90"
        viewBox="0 0 40 40"
      >
        {/* Background ring */}
        <circle
          cx="20"
          cy="20"
          r={radius}
          fill="none"
          stroke="#E5E7EB" /* light-grey */
          strokeWidth={strokeWidth}
        />

        {/* Progress ring */}
        <circle
          cx="20"
          cy="20"
          r={radius}
          fill="none"
          stroke="#3B82F6" /* Tailwind blue-500 */
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>

      {/* Sparkle icon in center */}
      <div className="absolute inset-0 flex items-center justify-center">
        <Sparkles className="w-2.5 h-2.5 text-blue-500" />
      </div>
    </div>
  );
}

export default ProgressCircle;
